import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DevicesService } from '@rocksoft/mdm-sdk-v2';
import { mergeMap } from 'rxjs/operators';
import { DevicesResolverActions, DevicesApiActions } from './mdm-devices.actions';
import { safeMap } from '../effects.helpers';

@Injectable()
export class DeviceEffects {
  constructor(
    private readonly api: DevicesService,
    private readonly actions$: Actions
  ) {}

  loadSettingsEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DevicesResolverActions.deviceRequested),
      mergeMap(() =>
        safeMap(
          this.api.getDevices('2.0'),
          (devices) => DevicesApiActions.devicesLoaded({ devices }),
          (error) => DevicesApiActions.devicesLoadedError({ error })
        )
      )
    );
  });
}
